import { mapPaginationParams } from '~/utils/ct/composables/helpers/apiHelpers';
import type { ApiParams } from '~~/types/commercetools';
import { ALLOWED_METHODS } from '~~/types/expondoMiddleware';
import { EXPONDO_MIDDLEWARE_ROUTES } from '~~/constants/routes';

export function useProductApi() {

  const apiFetch = useApiFetch();
  
  const search = async <T> ({
    customQuery,
    ...searchParams
  }: ApiParams): Promise<T | null> => {

    const apiSearchParams = [
      {
        ...searchParams,
        ...mapPaginationParams(searchParams),
      },
      customQuery,
    ];

    try {

      const endpoint = `${EXPONDO_MIDDLEWARE_ROUTES.CT.ROOT}${EXPONDO_MIDDLEWARE_ROUTES.CT.GET_PRODUCT}`;
      const fullPath = `${EXPONDO_MIDDLEWARE_ROUTES.ROOT}${endpoint}`;

      return await apiFetch<T>(fullPath, {
        method: ALLOWED_METHODS.post,
        body: apiSearchParams,
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
      });
    
    } catch (error: unknown) {

      console.error('Error during fetching product data: ', error);

      return null;
    
    }
  
  };

  return {
    search,
  };

}
